export type OkxLoginParameters = {
    apiKey: string;
    apiSecret: string;
    passphrase: string;
    useTestnet?: boolean;
};
